import axios from "axios";

export default class Cart {
    constructor() {
        if (document.getElementById('pageCart') !== null) {
            this.initCartRows();
            this.initDiscountCode();
        }
    }

    initCartRows() {
        const rows = document.querySelectorAll('#cartContainer .item');

        rows.forEach(row => {
            let btnMinus = row.querySelector('.btn-minus');
            let inputQuantity = row.querySelector('.input-quantity');
            let btnPlus = row.querySelector('.btn-plus');
            let btnDelete = row.querySelector('.btn-delete');


            btnMinus.addEventListener('click', e => {
                this.modifyQuantity(row, 1, '-');
            });

            btnPlus.addEventListener('click', e => {
                this.modifyQuantity(row, 1, '+');
            });

            inputQuantity.addEventListener('click', e => {
                inputQuantity.setSelectionRange(0, inputQuantity.value.length)
            });

            inputQuantity.addEventListener('keydown', e => {
                if (timeout) {
                    clearTimeout(timeout);
                }
                let that = this;
                let timeout = window.setTimeout(e => {
                    that.modifyQuantity(row, inputQuantity.value);
                }, 600);
            });

            btnDelete.addEventListener('click', e => {
                let icon = btnDelete.querySelector('i');
                icon.classList.remove('icon-trash');
                icon.classList.add('loader', 'loader-alt');
                this.deleteRow(row)
            });
        });
    }

    modifyQuantity(row, num, type = null) {
        let inputQuantity = row.querySelector('.input-quantity');
        let rowTotal = row.querySelector('.row-total');
        let stock = row.querySelector('.stock');
        let cartSubtotal = document.querySelector('.cart-subtotal');
        let cartDiscountContainer = document.querySelector('.cart_discount_container');
        let cartDiscount = document.querySelector('.cart-discount');
        let shippingCosts = document.querySelector('.shipping-costs');
        let cartTotal = document.querySelector('.cart-total');
        let cartSum = document.querySelector('.cart-sum');
        let cartInfo = document.querySelector('header .cart > div');
        let loader = row.querySelector('.loader');
        let discountCodeMessage = document.getElementById('discountCodeMessage');

        if (num === '') {
            num = 1;
        }
        num = parseInt(num);

        let value = num;

        if (type === '-') {
            value = Math.max(1, (parseInt(inputQuantity.value) - num));
        } else if (type === '+') {
            value = parseInt(inputQuantity.value) + num;
        }

        loader.classList.add('show');

        axios({
            method: 'post',
            url: '/winkelmandje/aanpassen',
            data: {
                row_id: row.dataset.rowId,
                quantity: value
            }
        })
            .then(response => { // success
                let data = response.data;

                if(data.cart_discount === '€ 0,00') {
                    cartDiscountContainer.classList.add('d-none');
                } else {
                    cartDiscountContainer.classList.remove('d-none');
                }

                if(data.discount_message){
                    discountCodeMessage.innerText = data.discount_message;
                    discountCodeMessage.classList.add('text-warning');
                    discountCodeMessage.classList.remove('d-none');
                } else {
                    if(data.cart_discount !== '€ 0,00') {
                        discountCodeMessage.innerText = 'De kortingscode is toegepast.';
                        discountCodeMessage.classList.remove('text-warning');
                        discountCodeMessage.classList.add('text-success');
                        discountCodeMessage.classList.remove('d-none');
                    } else {
                        discountCodeMessage.classList.remove('text-warning');
                        discountCodeMessage.classList.add('d-none');
                    }
                }

                rowTotal.innerText = data.row_total;
                cartSubtotal.innerText = data.cart_subtotal;
                cartDiscount.innerText = '- ' + data.cart_discount;
                shippingCosts.innerText = data.shipping_costs;
                cartTotal.innerText = data.cart_total;
                cartSum.innerText = '(' + data.cart_sum + ')';
                cartInfo.innerText = data.cart_sum;

                if (data.message) {
                    stock.innerHTML = '<span class="availability in-stock">Nog ' + data.stock + ' stuk' + (data.stock > 0 ? 's' : '') + ' direct leverbaar</span>';
                } else {
                    if (data.quantity <= data.stock) {
                        stock.innerHTML = '<span class="availability in-stock">Direct leverbaar</span>';
                    } else if (data.stock > 0) {
                        stock.innerHTML = '<span class="availability in-stock">' + data.stock + ' stuk' + (data.stock > 1 ? 's' : '') + ' direct leverbaar</span>' +
                            '<span class="availability out-of-stock">' + (data.quantity - data.stock) + ' stuk' + (data.quantity - data.stock > 1 ? 's' : '') + ' leverbaar in 5-7 werkdagen</span>';
                    } else {
                        stock.innerHTML = '<span class="availability out-of-stock">Leverbaar in 5-7 werkdagen</span>';
                    }
                }

                const quantity = parseInt(data.quantity);
                inputQuantity.value = parseInt(quantity);
            })
            .catch(function (error) { // error
                console.log(error);
            })
            .then(function () { // always
                loader.classList.remove('show');
            });
    }

    deleteRow(row) {
        let cartSubtotal = document.querySelector('.cart-subtotal');
        let cartDiscountContainer = document.querySelector('.cart_discount_container');
        let cartDiscount = document.querySelector('.cart-discount');
        let shippingCosts = document.querySelector('.shipping-costs');
        let cartTotal = document.querySelector('.cart-total');
        let cartSum = document.querySelector('.cart-sum');
        let cartInfo = document.querySelector('header .cart > div');
        let discountCodeMessage = document.getElementById('discountCodeMessage');

        axios({
            method: 'post',
            url: '/winkelmandje/verwijderen',
            data: {
                row_id: row.dataset.rowId
            }
        })
            .then(response => { // success
                let data = response.data;

                if (data.cart_sum > 0) {

                    if(data.cart_discount === '€ 0,00') {
                        cartDiscountContainer.classList.add('d-none');
                    } else {
                        cartDiscountContainer.classList.remove('d-none');
                    }

                    if(data.discount_message){
                        discountCodeMessage.innerText = data.discount_message;
                        discountCodeMessage.classList.add('text-warning');
                        discountCodeMessage.classList.remove('d-none');
                    } else {
                        if(data.cart_discount !== '€ 0,00') {
                            discountCodeMessage.innerText = 'De kortingscode is toegepast.';
                            discountCodeMessage.classList.remove('text-warning');
                            discountCodeMessage.classList.add('text-success');
                            discountCodeMessage.classList.remove('d-none');
                        } else {
                            discountCodeMessage.classList.remove('text-warning');
                            discountCodeMessage.classList.add('d-none');
                        }
                    }

                    cartSubtotal.innerText = data.cart_subtotal;
                    cartDiscount.innerText = '- ' + data.cart_discount;
                    shippingCosts.innerText = data.shipping_costs;
                    cartTotal.innerText = data.cart_total;
                    cartSum.innerText = '(' + data.cart_sum + ')';
                    cartInfo.innerText = data.cart_sum;

                    row.classList.add('hide');
                    window.setTimeout(e => {
                        row.remove();
                    }, 300);
                } else {
                    const cartContainer = document.getElementById('cartContainer');
                    cartContainer.classList.add('hide');
                    window.setTimeout(e => {
                        cartContainer.classList.remove('hide');
                        cartContainer.innerText = '';
                        cartInfo.classList.remove('show')
                        cartSum.remove();

                        let div = document.createElement('div');
                        div.classList.add('alert', 'alert-info');
                        div.innerHTML = 'Er zitten nog geen producten in uw winkelmand. <a href="/">Verder winkelen.</a>';
                        cartContainer.append(div);
                    }, 300);
                }
            })
            .catch(function (error) { // error
                console.log(error);
            })
            .then(function () { // always
            });
    }

    initDiscountCode() {
        const discountCode = document.getElementById('discountCode');
        const form = discountCode.querySelector('form');
        const input = form.querySelector('input');
        const icon = form.querySelector('button i');

        let cartSubtotal = document.querySelector('.cart-subtotal');
        let shippingCosts = document.querySelector('.shipping-costs');
        let cartDiscountContainer = document.querySelector('.cart_discount_container');
        let cartDiscount = document.querySelector('.cart-discount');
        let cartTotal = document.querySelector('.cart-total');
        let spanDiscountCode = document.querySelector('.discount_code');
        let discountCodeMessage = document.getElementById('discountCodeMessage');

        form.addEventListener('submit', e => {
            e.preventDefault();
            discountCodeMessage.classList.add('d-none');
            discountCodeMessage.classList.remove('text-danger', 'text-success');

            icon.classList.remove('icon-arrow-right');
            icon.classList.add('loader');

            axios({
                method: 'post',
                url: '/winkelmandje/kortingscode',
                data: {
                    discount_code: input.value
                }
            })
                .then(response => { // success
                    let data = response.data;

                    if (!data.discount_code) {
                        cartDiscountContainer.classList.add('d-none');
                        discountCodeMessage.innerText = 'De kortingscode is niet (meer) geldig';
                        discountCodeMessage.classList.add('text-danger');
                        discountCodeMessage.classList.remove('d-none');

                        cartSubtotal.innerText = data.cart_subtotal;
                        shippingCosts.innerText = data.shipping_costs;
                        cartTotal.innerText = data.cart_total;
                    } else {
                        if(data.discount_message){
                            discountCodeMessage.innerText = data.discount_message;
                            discountCodeMessage.classList.add('text-warning');
                        } else {
                            discountCodeMessage.innerText = 'De kortingscode is toegepast.';
                            discountCodeMessage.classList.add('text-success');
                        }

                        discountCodeMessage.classList.remove('d-none');

                        if(data.cart_discount === '€ 0,00') {
                            cartDiscountContainer.classList.add('d-none');
                        } else {
                            cartDiscountContainer.classList.remove('d-none');
                        }

                        cartSubtotal.innerText = data.cart_subtotal;
                        cartDiscount.innerText = '- ' + data.cart_discount;
                        shippingCosts.innerText = data.shipping_costs;
                        cartTotal.innerText = data.cart_total;
                        spanDiscountCode.innerText = data.discount_code;
                    }
                })
                .catch(function (error) { // error
                    console.log(error);
                })
                .then(function () { // always
                    icon.classList.remove('loader');
                    icon.classList.add('icon-arrow-right');
                });
        });
    }
}
